import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ZeroState, FileDownload, SharedMessages as sharedMsgs } from 'ecs-react-components/dist/index.es';
import history from '../../history';
import { messages } from './HealthSummary.i18n';
import {
  loadHealthSummaryHtml,
  setDownloadPath,
  getMostRecentHealthSummaryIdentifier,
} from '../../redux/modules/health-summary/health-summary-middleware';
import { healthSummaryListLoaded, updateHealthSummaryIdentifier }
from '../../redux/modules/health-summary/actions/creators';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';
import { findCcdaExternalSystems } from '../../redux/modules/health-summary/external-systems-mapper';
import EmailForm from './EmailForm';
import CcdaOptionsForm from './CcdaOptionsForm';
import SendSecurelyForm from './SendSecurelyForm';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

class HealthSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmailModal: false,
      showOptionsModal: false,
      showSendSecurelyModal: false,
      reloadHtml: true,
    };
  }

  componentDidMount() {
    const { patient: { patientId }, externalSystems: { externalSystems }, healthSummary } = this.props;
    if (patientId) {
      this.state = { initial: true };

      let ccdaExternalSystems = null;
      if (externalSystems && externalSystems.length) {
        ccdaExternalSystems = findCcdaExternalSystems(externalSystems);
      }

      if (
        !healthSummary.currentIdentifier &&
        ccdaExternalSystems &&
        ccdaExternalSystems.length === 1
      ) {
        this.props.dispatch(
          getMostRecentHealthSummaryIdentifier(patientId, ccdaExternalSystems[0].ifSystemId));
      }
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const { dispatch,
      healthSummary: {
        healthSummaryHtml,
        currentIdentifier,
      },
      patient: { patientId },
      externalSystems: { externalSystems } } = nextProps;

    // Load CCDA HTML
    if (!healthSummaryHtml
        && externalSystems
        && externalSystems.length
        && currentIdentifier
        && this.state.reloadHtml) {
      let extSystem = externalSystems[0];
      if (currentIdentifier) {
        extSystem = externalSystems.find((x) => x.ifSystemId === currentIdentifier.ifSystemId);
      }
      if (extSystem) {
        dispatch(
          callWithLoadingIndicator(
            'HealthSummary',
            () => dispatch(loadHealthSummaryHtml(patientId, currentIdentifier, extSystem.patientDisplayName)))
        );
      }
    }
  }

  getDownloadPathPathOnly() {
    const api = this.props.healthSummary.downloadPath;
    const queryStringStart = api.indexOf('?');
    return api.substring(0, queryStringStart);
  }

  getDownloadPathQueryItems() {
    const api = this.props.healthSummary.downloadPath;
    const queryStringStart = api.indexOf('?') + 1;
    const queryString = api.substring(queryStringStart);
    const queryStringValues = queryString.split('&');
    const queryStringParamsObject = {};
    for (let i = 0; i < queryStringValues.length; i += 1) {
      const parts = queryStringValues[i].split('=');
      queryStringParamsObject[parts[0]] = parts[1];
    }
    return queryStringParamsObject;
  }

  viewCcda = (ccdaIdentifier) => (e) => {
    e.preventDefault();
    const {
      dispatch,
    } = this.props;

    if (ccdaIdentifier) {
      dispatch(healthSummaryListLoaded([]));
      dispatch(updateHealthSummaryIdentifier(ccdaIdentifier));
    }
  }

  cancelViewingCcda = () => {
    history.push('/');
  }

  closeEmailModal = () => {
    this.setState({ showEmailModal: false });
  }

  canTriggerButton = (event) => (
    event &&
    (event.type === 'click' ||
    (event.type === 'keypress' &&
      (event.charCode === 13 || event.keyCode === 13)))
  );

  openEmailModal = (event) => {
    if (this.canTriggerButton(event)) {
      this.setState({ showEmailModal: true });
    }
  }

  closeOptionsModal = () => {
    this.setState({ showOptionsModal: false });
  }

  closeSendSecurelyModal = () => {
    this.setState({ showSendSecurelyModal: false });
  }

  openOptionsModal = (event) => {
    if (this.canTriggerButton(event)) {
      this.setState({
        showOptionsModal: true,
        reloadHtml: false,
      });
    }
  }

  openSendSecurelyModal = (event) => {
    if (this.canTriggerButton(event)) {
      if (!this.props.healthSummary.currentIdentifier.sendSecurelyDisabled) {
        this.setState({ showSendSecurelyModal: true });
      } else {
        // Fire a warning
        this.props.dispatch(MsgBarActions.showErrorMessage('noCcdaConfigured'));
      }
    }
  }

  handleDownload = (event) => {
    if (this.canTriggerButton(event)) {
      this.props.dispatch(setDownloadPath(this.props.patient.patientId, this.props.healthSummary.currentIdentifier));
    }
  }

  handleDownloadComplete = () => {
    this.props.dispatch(setDownloadPath());
  }

  renderCcdaList() {
    const getLabel = (id) => 'label_' + id;

    return (
      <div>
        <p><FormattedMessage {...messages.datelist.title} /></p>
        <div className="row">
          <div className="col-sm-4">
            <table className="table" data-qa-container="HealthSummaryDates">
              <thead>
                <tr>
                  <th colSpan="2"><FormattedMessage {...messages.datelist.tableheader} /></th>
                </tr>
              </thead>
              <tbody>
                { this.props.healthSummary.filteredCcdas.map((ccda, idxkey) => (
                    <tr key={idxkey}>
                      <td>
                        <span id={getLabel(idxkey)}>
                          { moment(ccda.displayDate).format('ll') }
                        </span>
                      </td>
                      <td>
                        <a
                          style={{ cursor: 'pointer' }}
                          tabIndex="0"
                          onClick={ this.viewCcda(ccda) }
                          aria-describedby={getLabel(idxkey) + ' ccdalabel'}
                          role="button"
                        >
                          <FormattedMessage {...messages.datelist.viewlabel} />
                        </a>
                      </td>
                    </tr>
                ))}
              </tbody>
            </table>
            <a className="btn btn-default" type="button" onClick={ this.cancelViewingCcda } role="button" tabIndex="0">
              <FormattedMessage {...messages.datelist.cancellabel} />
            </a>
          </div>
        </div>
        <span id="ccdalabel" className="sr-only" >
          <FormattedMessage {...messages.page.ccdaLabel} />
        </span>
      </div>
    );
  }

  renderZeroState(messageId, iconCss) {
    return (
      <div>
        <ZeroState zeroStateMessage={ <FormattedMessage { ...messageId } /> }
          stateIconCss={iconCss || 'fa-file-text-o'} showZeroHeader={false}
        />
      </div>
    );
  }

  renderCcda() {
    return (
      <div data-qa-container="healthSummaryContainer">
        <div className="spacer tiny"></div>
        <div className="spacer small"></div>
        <div className="row">
          <div className="col-xs-12">
            <FormattedMessage {...messages.page.introduction} />
          </div>
        </div>
        <div tabIndex="0" dangerouslySetInnerHTML={{ __html: this.props.healthSummary.healthSummaryHtml }}></div>
      </div>
    );
  }

  renderContent(ccdaExternalSystems) {
    if (this.props.healthSummary.filteredCcdas.length > 1) {
      return this.renderCcdaList();
    }
    // Based on the number of external systems and the presence of HTML to view, show the user some content
    if (this.props.healthSummary.healthSummaryHtml) {
      return this.renderCcda();
    }

    if (ccdaExternalSystems && ccdaExternalSystems.length > 1) {
      if (this.props.externalSystems.userSelectedASystem) {
        // No html loaded and have selected external system Id
        return this.renderZeroState(messages.page.noHealthSummary);
      }
      // No html loaded and have more than one external systems and
      // user has not selected any options.
      return this.renderZeroState(messages.page.multipleExternalSystems, 'fa fa-files-o');
    }

    return this.renderZeroState(messages.page.noHealthSummary);
  }

  render() {
    const { externalSystems: { externalSystems }, healthSummary } = this.props;
    let ccdaExternalSystems = null;
    if (externalSystems && externalSystems.length > 0) {
      ccdaExternalSystems = findCcdaExternalSystems(externalSystems);
    }
    return (
      <div id="health-summary-content">
        {
          this.state.showEmailModal ?
          <EmailForm showModal={this.state.showEmailModal} close={this.closeEmailModal} /> :
            null
        }
        {
          this.state.showOptionsModal ?
          <CcdaOptionsForm
            showModal={this.state.showOptionsModal}
            close={this.closeOptionsModal}
            language={this.props.language}
            handleReloadHtml={
              () => {
                this.setState({ reloadHtml: true });
              }
            }
          /> :
            null
        }
        {
          this.state.showSendSecurelyModal ?
          <SendSecurelyForm showModal={this.state.showSendSecurelyModal} close={this.closeSendSecurelyModal} /> :
            null
        }
        <div className="row">
            <div className="col-xs-12">
              <h1 id="content" className="page-title" data-qa-item="pageHeader" tabIndex="0">
                <FormattedMessage { ...messages.page.title } />
              </h1>
              <div className="top-right-utility-buttons xsmall-below-title">
                { healthSummary && healthSummary.healthSummaryHtml ?
                  <span>
                    <a type="button" className="btn btn-default button-with-space" tabIndex="0"
                      data-qa-item="SendByEmailButton"
                      onClick={ this.openEmailModal }
                      onKeyPress={ this.openEmailModal }
                      aria-describedby="opensPopupLabel" role="button"
                    >
                      <span className="fa fa-envelope"></span>
                      <FormattedMessage {...messages.page.sendByEmail} />
                    </a>
                    <a type="button" className="btn btn-default button-with-space"
                      data-qa-item="SendSecurelyButton"
                      onClick={ this.openSendSecurelyModal }
                      onKeyPress={ this.openSendSecurelyModal }
                      tabIndex="0" aria-describedby="opensPopupLabel" role="button"
                    >
                      <span className="fa fa-envelope"></span>
                      <FormattedMessage {...messages.page.sendSecurely} />
                    </a>
                    <a type="button" className="btn btn-default button-with-space" tabIndex="0"
                      data-qa-item="DownloadButton"
                      onClick={ this.handleDownload }
                      onKeyPress={ this.handleDownload }
                      role="button"
                      aria-describedby="downloadMessage"
                    >
                      <span className="fa fa-cloud-download"></span>
                      <FormattedMessage {...messages.page.download} />
                    </a>
                  </span>
                  : null}
                { ccdaExternalSystems && ccdaExternalSystems.length > 0 ?
                  <a type="button" className="btn btn-link theme" data-toggle="modal" tabIndex="0"
                    data-qa-item="OptionsButton" data-target="#health-summary-options"
                    onClick={ this.openOptionsModal }
                    onKeyPress={ this.openOptionsModal }
                    aria-describedby="opensPopupLabel"
                    role="link"
                  >
                    <span className="fa fa-cog"></span>
                    <FormattedMessage {...messages.page.options} />
                  </a> : null}
                <span className="sr-only" id="opensPopupLabel">
                  <FormattedMessage {...sharedMsgs.labels.openNewDialog} />
                </span>
                <span className="sr-only" id="downloadMessage">
                  <FormattedMessage {...messages.page.downloadMessage} />
                </span>
              </div>
            </div>
        </div>
        <div>
          <LoadingIndicatorContainer loadingKey="HealthSummary" >
          {
            this.renderContent(ccdaExternalSystems)
          }
          </LoadingIndicatorContainer>
        </div>
        {
          this.props.healthSummary.downloadPath === null || this.props.healthSummary.downloadPath === undefined ? null :
            <FileDownload
              onDownloadComplete={this.handleDownloadComplete}
              actionPath={this.props.healthSummary.downloadPath}
            />
        }
      </div>
    );
  }
}

HealthSummary.propTypes = {
  dispatch: PropTypes.func,
  patient: PropTypes.object,
  healthSummary: PropTypes.object,
  externalSystems: PropTypes.object,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  healthSummary: state.healthSummary,
  externalSystems: state.externalSystems,
  patient: state.profile.patient,
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(injectIntl(HealthSummary));